<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="bill_payment.payment_id && bill_payment.payment_id > 0" @invoke-method="dbGetBillPayment(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="bill_payment.payment_id && bill_payment.payment_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('bill_payments.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in bill_payment_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != bill_payment.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('bill_payments.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_bill_payment.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'bill_payments' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="bill_payment.status" class="ribbon ribbon-top-right" :class="`ribbon-${bill_payment.status_class}`">
                            <span class="ribbon-span">{{ bill_payment.status }}</span>
                        </div>
                        <v-form ref="formBillPayment">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="bill_payment_dialog"
                                    v-model="bill_payment.payment_id"
                                    :label="$t('lang.payment_id')"
                                    :counter="showCounter(bill_payment.payment_id, 'bill_payments.payment_id')"
                                    :rules="ifValid('bill_payments.payment_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="bill_payment.bill_id"
                                    :label="$t('lang.bill_id')"
                                    :items="bills"
                                    item-value="bill_id"
                                    item-text="bill_id"
                                    :rules="ifValid('bill_payments.bill_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="bill_payment.company_id"
                                    :label="$t('lang.company_id')"
                                    :items="customers"
                                    item-value="company_id"
                                    item-text="company"
                                    :rules="ifValid('bill_payments.company_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="bill_payment.payment_date"
                                    :label="$t('lang.payment_date')"
                                    :rules="ifValid('bill_payments.payment_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="bill_payment.amount"
                                    :label="$t('lang.amount')"
                                    :counter="showCounter(bill_payment.amount, 'bill_payments.amount')"
                                    :rules="ifValid('bill_payments.amount')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="bill_payment.currency_id"
                                    :label="$t('lang.currency_id')"
                                    :items="currencies"
                                    item-value="currency_id"
                                    item-text="currency_id"
                                    :rules="ifValid('bill_payments.currency_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="bill_payment.exchange_rate"
                                    :label="$t('lang.exchange_rate')"
                                    :counter="showCounter(bill_payment.exchange_rate, 'bill_payments.exchange_rate')"
                                    :rules="ifValid('bill_payments.exchange_rate')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="bill_payment.payment_method_id"
                                    :label="`${$t('lang.payment_method_id')} *`"
                                    :items="payment_method_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('bill_payments.payment_method_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="bill_payment.payment_status_id"
                                    :label="`${$t('lang.payment_status_id')} *`"
                                    :items="payment_status_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('bill_payments.payment_status_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="bill_payment.reference_number"
                                    :label="$t('lang.reference_number')"
                                    :counter="showCounter(bill_payment.reference_number, 'bill_payments.reference_number')"
                                    :rules="ifValid('bill_payments.reference_number')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="bill_payment.notes"
                                    :label="$t('lang.notes')"
                                    :counter="showCounter(bill_payment.notes, 'bill_payments.notes')"
                                    :rules="ifValid('bill_payments.notes')"
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'bill_payments' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveBillPayments">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_bill_payment"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_bill_payment')"
                :message="$t('lang.delete_bill_payment_confirm')"
                @onConfirm="deleteBillPayments()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_bill_payment_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteBillPaymentDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            bill_payment: {},
            file_name: "",
            dbGetBillPayment: _.debounce(this.getBillPayment, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchBillPayment", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.bill_payment) {
                        this.bill_payment = this.assignObj2(data.bill_payment, this.rules_bill_payments);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=bill_payment_status&sort_by=2",
                            method: "get",
                            stateProperty: "bill_payment_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "bill_payments", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchBillPayment", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.bill_payment) {
                        next((vm) => {
                            vm.bill_payment = vm.assignObj2(data.bill_payment, vm.rules_bill_payments);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=bill_payment_status&sort_by=2",
                                method: "get",
                                stateProperty: "bill_payment_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "bill_payments", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=bill_payment_status&sort_by=2",
            method: "get",
            stateProperty: "bill_payment_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_bill_payments: (state) => state.bill_payments.rules_bill_payments,
            bill_payment_status_options: (state) => state.settings.bill_payment_status_options,
            bill_payments: (state) => state.bill_payments.bill_payments,
            selectedBillPayment: (state) => state.bill_payments.selectedBillPayment,
            bills: (state) => state.bills.bills,
            currencies: (state) => state.currencies.currencies,
        }),
    },
    methods: {
        ...mapActions(["fetchBillPayment", "saveBillPayment", "deleteBillPayment", "printBillPayment", "fetchBills", "fetchCustomers", "fetchCurrencies"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getBillPayment(pg_refresh = false) {
            this.startLoader();

            this.fetchBillPayment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.bill_payment) {
                    this.bill_payment = this.assignObj2(data.bill_payment, this.rules_bill_payments);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printBillPayment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.bill_payment) {
                    if (this.dev_mode) {
                        this.file_name = data.bill_payment.file_name;
                    } else {
                        this.$refs.print.printReport(data.bill_payment.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveBillPayments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formBillPayment")) {
                    let body = this.prepForm(this.bill_payment, this.rules_bill_payments);

                    this.saveBillPayment({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.bill_payment) {
                            this.$router.push({ name: "bill_payment", params: { id: data.bill_payment.payment_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { payment_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveBillPayments({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.bill_payment) {
                    this.bill_payment = this.assignObj2(data.bill_payment, this.rules_bill_payments);
                }
            });
        },
        deleteBillPayments() {
            this.deleteBillPayment({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "bill_payments" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchBillPayment({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.bill_payment) {
                        this.bill_payment = this.assignObj2(data.bill_payment, this.rules_bill_payments);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.bills.length == 0 || force == true) await this.fetchBills({ body: { options: 1 } });
            if (this.customers === null || force == true) await this.getCustomers();
            if (this.currencies.length == 0 || force == true) await this.fetchCurrencies({ body: { options: 1 } });
        },
    },
    created() {},
};
</script>
